import {
  getUserInfoService,
  // loginService,
  loginService2,
} from "../services/loginService";

export const getUserInfo = (token) =>
  new Promise((resolve, reject) => {
    getUserInfoService(token)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });

export const login = ({ user, password }) =>
  new Promise((resolve, reject) => {
    loginService2({
      userName: user,
      password,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
